import { Icon } from '@iconify/react/dist/iconify.js';
import React, { useEffect, useState } from 'react';
import { useFormik } from 'formik';
import * as Yup from 'yup';
import { useFetch } from '../hook/useFecth';
import useErrors from '../hook/useErrors';
import server from '../services/server';
import AddressInput from './AddressInput';
import PhoneInputMasked from './masks/PhoneInputMasked';
import { Navigate, useNavigate } from 'react-router-dom';
import DocumentInputMasked from './masks/DocumentInputMasked';
import { map } from 'jquery';
import { PriceInputMasked } from './masks/PriceInputMasked';
import { useConfirm } from '../context/BootstrapConfirm';


function ViewProdutosLayer({ data, mutate, backTo = '/produtos' }) {
    const { setErrors, toast } = useErrors();
    const confirm = useConfirm();
    const [passwordVisible, setPasswordVisible] = useState(false);
    const [confirmPasswordVisible, setConfirmPasswordVisible] = useState(false);
    const navigate = useNavigate();
    const { getFieldProps, errors, isSubmitting, isValid, handleSubmit, handleBlur, setFieldValue, touched, values, setValues, resetForm } =
        useFormik({
            initialValues: {
                nome: '',
                descricao: '',
                valor: '',
                status: true,
                action: 'create', 
                estoque: '',
            },
            // validationSchema: validationSchema,
            validateOnMount: true,
            validateOnChange: true,
            onSubmit: async (values, { setSubmitting, resetForm }) => {
                try {
                    if (values.action === 'update') {
                        await server.put(`produto/${values.id}`, values);
                        mutate();
                        toast.success('Produto alterado com sucesso!');
                        setSubmitting(false);
                    }
                    if (values.action === 'create') {
                        await server.post(`produto`, values);

                        toast.success('Produto cadastrado com sucesso!');
                        setSubmitting(false);
                    }

                } catch (error) {
                    setSubmitting(false);
                    console.log(error);
                    setErrors(error);
                }
            },
        });
    useEffect(() => {
        if (Boolean(data)) {
            setValues({
                ...values,
                ...data,
                estoque: data.estoque ?? data.quantidade ?? data.qtd ?? '',
                action: 'update'
            }, true);
        }
    }, [data]);

    function handleCheckboxChange(e) {
        setFieldValue('status', e.target.checked);
    };

    async function handleExcluirProduto() {
        try {
            await confirm({
                title: 'Excluir produto',
                message: `Tem certeza que deseja excluir o produto #${data?.id}? Essa ação não pode ser desfeita.`,
                confirmText: 'Excluir',
            });
            await server.delete(`produto/${data.id}`);
            toast.success('Produto excluído com sucesso!');
            navigate(backTo);
        } catch (error) {
            if (error) setErrors(error);
        }
    }
//wesley

    return (
        <div className='card'>
            <div className='card-body'>
                <form onSubmit={handleSubmit}>
                    <div className="row">
                        <div className="mb-20 col-xxl-3 col-xl-3 col-md-4 col-sm-12">
                            <label htmlFor="nome" className="form-label text-primary-light text-sm fw-semibold mb-8">
                                Nome
                                <span className="text-danger-600">*</span>{' '}
                                {touched.nome && errors.nome && <span className="text-danger-600">{errors.nome}</span>}
                            </label>
                            <input type="text" className="form-control radius-8" id="nome" placeholder="Nome do produto" {...getFieldProps('nome')} />
                        </div>
                        <div className="mb-20 col-xxl-3 col-xl-3 col-md-4 col-sm-12">
                            <label htmlFor="descricao" className="form-label text-primary-light text-sm fw-semibold mb-8">
                                Descrição
                                <span className="text-danger-600">*</span>{' '}
                                {touched.descricao && errors.descricao && <span className="text-danger-600">{errors.descricao}</span>}
                            </label>
                            <input type="text" className="form-control radius-8" id="descricao" placeholder="Descrição do produto" {...getFieldProps('descricao')} />
                        </div>
                        <div className="mb-20 col-xxl-3 col-xl-3 col-md-4 col-sm-12">
                            <label className="form-label text-neutral-900 fw-bold" htmlFor="valor">
                                Valor
                            </label>
                            <PriceInputMasked
                                {...getFieldProps('valor')}
                                className="form-control border border-neutral-200 radius-8"
                                id="valor"
                                placeholder="Ex: R$ 1.500,00"
                            />
                            {touched.valor && errors.valor && <div className="invalid-feedback d-block">{errors.valor}</div>}
                        </div>
                        <div className="mb-20 col-xxl-3 col-xl-3 col-md-4 col-sm-12">
                            <label htmlFor="estoque" className="form-label text-primary-light text-sm fw-semibold mb-8">
                                Quantidade
                                <span className="text-danger-600">*</span>{' '}
                                {touched.estoque && errors.estoque && <span className="text-danger-600">{errors.estoque}</span>}
                            </label>
                            <input type="text" className="form-control radius-8" id="estoque" placeholder="Quantidade no estoque" {...getFieldProps('estoque')} />
                        </div>
                    </div>
                    <footer className="d-flex card-footer bg-white align-items-cent justify-content-end gap-3 mt-10">
                        <div className="form-switch  switch-primary   d-flex align-items-center gap-3">

                            <input
                                className="form-check-input"
                                type="checkbox"
                                role="switch"
                                id="switch2"
                                defaultChecked={false}
                                checked={values.status}

                                onClick={handleCheckboxChange}
                                {...getFieldProps('status')}

                            />
                            <label
                                className="form-check-label line-height-1 fw-medium text-secondary-light"
                                htmlFor="switch2"
                            >
                                status
                            </label>
                        </div>
                        {Boolean(data?.id) && (
                            <button
                                type="button"
                                className="btn btn-danger border border-danger text-sm px-24 py-8 radius-8"
                                onClick={handleExcluirProduto}
                            >
                                Excluir
                            </button>
                        )}
                        <button
                            type="button"
                            className="btn btn-primary border border-primary-600 text-sm px-24 py-8 radius-8"
                            onClick={() => navigate(backTo)}
                        >
                            Voltar
                        </button>
                        <button
                            type="submit"
                            className="btn btn-success border border-success text-sm px-24 py-8 radius-8"
                            disabled={isSubmitting || !isValid}
                        >
                            {isSubmitting ? 'Salvando...' : 'Salvar'}
                        </button>
                    </footer>
                </form>
            </div>
        </div >
    );
}

export default ViewProdutosLayer;
